var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"icons"},[_c('button',{staticClass:"icon",on:{"click":_vm.edit}},[_vm._v("編集")]),_c('button',{staticClass:"icon",on:{"click":_vm.doblecheck}},[_vm._v(" 削除 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }